import createIcon from '../../createIcon';

/**
 * @component @name LocalPrintshop
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkgOEg1QzMuMzQgOCAyIDkuMzQgMiAxMVYxN0g2VjIxSDE4VjE3SDIyVjExQzIyIDkuMzQgMjAuNjYgOCAxOSA4Wk0xNiAxOUg4VjE0SDE2VjE5Wk0xOSAxMkMxOC40NSAxMiAxOCAxMS41NSAxOCAxMUMxOCAxMC40NSAxOC40NSAxMCAxOSAxMEMxOS41NSAxMCAyMCAxMC40NSAyMCAxMUMyMCAxMS41NSAxOS41NSAxMiAxOSAxMlpNMTggM0g2VjdIMThWM1oiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const LocalPrintshop = createIcon('LocalPrintshop', [
  [
    'path',
    {
      d: 'M19 8H5C3.34 8 2 9.34 2 11V17H6V21H18V17H22V11C22 9.34 20.66 8 19 8ZM16 19H8V14H16V19ZM19 12C18.45 12 18 11.55 18 11C18 10.45 18.45 10 19 10C19.55 10 20 10.45 20 11C20 11.55 19.55 12 19 12ZM18 3H6V7H18V3Z',
      key: '1kaod0',
    },
  ],
]);

export default LocalPrintshop;
